import classnames from 'classnames';
import { CSSProperties, useEffect } from 'react';
import './index.less';

type IconTopicProps = {
  type: string,
  style?: CSSProperties,
  className?: string,
  [key: string]: any
};

export default function IconTopic(props: IconTopicProps) {
  const {
    type,
    style = {},
    className = '',
    ...rest
  } = props;

  useEffect(() => {
    // @ts-ignore
    if (!IconTopic.isInitIcon) {
      // @ts-ignore
      IconTopic.isInitIcon = true;
      // @ts-ignore
      import('src/../public/icon-topic/iconfont.css');
    }
  }, []);
  return (
    <i
      className={classnames(
        'topic-iconfont',
        `${type}`,
        className,
      )}
      style={style}
      {...rest}
    />
  );
}
